import { useState } from 'react';
import { withRouter } from 'react-router-dom';
import BottomNavigation from '@material-ui/core/BottomNavigation/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction/BottomNavigationAction';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import classNames from 'classnames';

import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import HomeOff from '../../../../public/images/home_off.svg';

// import ReportingOff from "../../../../public/images/reporting_off.svg";
// import MonitoringOff from "../../../../public/images/monitoring_off.svg";
import AccountOff from '../../../../public/images/account_off.svg';
import AccountOn from '../../../../public/images/account_on.svg';
import TerminalOn from '../../../../public/images/mobile/terminal_on.svg';
import TerminalOff from '../../../../public/images/mobile/terminal_off.svg';

import styles from './BottomNavigation.module.css';

import useMediaQuery from '@material-ui/core/useMediaQuery';

const MainBottomNavigation = ({ history, t, location, darkMode: prefersDarkMode }) => {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {
        width: '100%',
        position: 'fixed',
        bottom: 0,
        padding: 0,
        color: '#eab329',
        backgroundColor: prefersDarkMode ? 'rgba(45,45,45,0.60)' : 'rgba(255,255,255,0.85)'
      }
    })
  );

  const useStylesNav = makeStyles((theme: Theme) => ({
    root: {
      color: '#dcdcdc',
      '&$selected': {
        color: '#eab329'
      },
      '&$label': {
        fontSize: '1em'
      }
    },
    selected: {},
    label: {
      position: 'absolute',
      bottom: '0',
      textTransform: 'uppercase'
    }
  }));

  const classes = useStyles();

  const navStyle = useStylesNav();

  const initPath = () => {
    switch (location.pathname) {
      case '/': {
        return 0;
      }
      /* case "/mobile-reporting": {
        return 1;
      } */
      /* case "/mobile-monitoring": {
        return 1;
      } */
      case '/mobile-poi':
      case '/mobile-poi/onboarding':
      case '/mobile-poi/authenticate': {
        return 1;
      }
      case '/my-account': {
        return 2;
      }
      default:
        return 0;
    }
  };

  const [value, setValue] = useState(initPath());

  const matches = useMediaQuery(`(max-width: 768px)`);

  const AccountIcon = () => {
    if (value !== 2) {
      return (
        <AccountOff
          className={classNames(styles.icon, {
            [styles.selected]: value === 2,
            [styles.notSelected]: value !== 2
          })}
        />
      );
    }

    return (
      <AccountOn
        className={classNames(styles.icon, {
          [styles.selected]: value === 2,
          [styles.notSelected]: false
        })}
      />
    );
  };

  const TerminalIcon = () => {
    if (value !== 1) {
      return <TerminalOff className={classNames(styles.icon, styles.terminalOff)} />;
    }

    return <TerminalOn className={classNames(styles.icon, styles.terminalOn)} />;
  };

  if (matches) {
    return (
      <BottomNavigation
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
          switch (newValue) {
            case 0: {
              history.push('/');

              break;
            }
            /* case 1: {
              history.push("/mobile-reporting");

              break;
            } */
            case 1: {
              history.push('/mobile-poi');

              break;
            }
            case 2: {
              history.push('/my-account');

              break;
            }
            default: {
              break;
            }
          }
        }}
        showLabels
        className={classes.root}
      >
        <BottomNavigationAction
          classes={{
            root: navStyle.root,
            selected: navStyle.selected,
            label: navStyle.label
          }}
          label={t('menu.home')}
          icon={
            <HomeOff
              className={classNames(styles.icon, {
                [styles.selected]: value === 0,
                [styles.notSelected]: value !== 0
              })}
            />
          }
        />

        {/* <BottomNavigationAction
          classes={{
            root: navStyle.root,
            selected: navStyle.selected,
            label: navStyle.label
          }}
          label={t("menu.reporting")}
          icon={
            <ReportingOff
              className={classNames(styles.icon, styles.reporting, {
                [styles.selected]: value === 1,
                [styles.notSelected]: value !== 1
              })}
            />
          }
        /> */}

        <BottomNavigationAction
          classes={{
            root: navStyle.root,
            selected: navStyle.selected,
            label: navStyle.label
          }}
          label={t('menu.poi')}
          icon={<TerminalIcon />}
        />
        <BottomNavigationAction
          classes={{
            root: navStyle.root,
            selected: navStyle.selected,
            label: navStyle.label
          }}
          label={t('header.myAccount')}
          icon={<AccountIcon />}
        />
      </BottomNavigation>
    );
  }
  return null;
};

export const mapStateToProps = (state) => {
  const {
    auth: { user, isCustomer },
    theme: { darkMode }
  } = state;

  const { permissions } = user;

  return { isCustomer, permissions, darkMode };
};

export default compose(withRouter, withTranslation(), connect(mapStateToProps, null))(MainBottomNavigation);
